import styled from 'styled-components';

import colors from 'themes/Main';

const { white, darkBlue, gray01 } = colors;

export const Container = styled.div`
  padding: 16px;
  background-color: ${white};
  border-radius: 4px;
  box-shadow: 0px 1px 8px rgba(215, 220, 230, 0.2),
    0px 3px 4px rgba(215, 220, 230, 0.12), 0px 3px 3px rgba(215, 220, 230, 0.14);
`;

export const CardHead = styled.small`
  display: block;
  margin-bottom: 16px;
  text-transform: uppercase;
  color: ${darkBlue};
  font-size: 14px;
  font-weight: 700;
`;

export const CardItem = styled.div`
  display: flex;
  align-items: flex-start;

  svg {
    min-width: 20px;
    max-width: 25px;
  }

  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const KnowleadgeDescription = styled.p`
  margin-bottom: 0;
  margin-left: 8px;
  color: ${gray01};
  font-size: 14px;

  span {
    color: ${darkBlue};
    font-weight: 600;
  }
`;
